import { useEffect, useState } from "react";
import { toast } from "react-toastify";

// Loads one Client Work report and reloads it when the date range changes; a late answer for an old range is dropped.
export const useReportData = (fetchReport, dateRange) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    let stale = false;
    (async () => {
      const result = await fetchReport(dateRange.from, dateRange.to);
      if (stale) {
        return;
      }
      if (result?.data?.IsSuccess === true) {
        setData(result.data.Data || []);
      } else {
        setData([]);
        toast.error(result?.data?.Message || "Could not load the report");
      }
    })();
    return () => {
      stale = true;
    };
  }, [fetchReport, dateRange.from, dateRange.to]);

  return data;
};
